import { isRef as a, computed as f, watch as p, onScopeDispose as y } from "vue";
import { useNamespace as h } from "./index559.js";
import { throwError as b } from "./index588.js";
import { hasClass as w, addClass as v, getStyle as C, removeClass as H } from "./index641.js";
import { getScrollBarWidth as S } from "./index704.js";
const B = (s, r = {}) => {
  a(s) || b(
    "[useLockscreen]",
    "You need to pass a ref param to this function"
  );
  const n = r.ns || h("popup"), o = f(() => n.bm("parent", "hidden"));
  let t = 0, e = !1, c = "0", d = !1;
  const l = () => {
    d || (d = !0, setTimeout(() => {
      typeof document > "u" || e && document && (document.body.style.width = c, H(document.body, o.value));
    }, 200));
  };
  p(s, (u) => {
    if (!u) {
      l();
      return;
    }
    d = !1, e = !w(document.body, o.value), e && (c = document.body.style.width, v(document.body, o.value)), t = S(n.namespace.value);
    const i = document.documentElement.clientHeight < document.body.scrollHeight, m = C(document.body, "overflowY");
    t > 0 && (i || m === "scroll") && e && (document.body.style.width = `calc(100% - ${t}px)`);
  }), y(() => l());
};
export {
  B as useLockscreen
};
